import { Component, OnInit } from '@angular/core';
import { SimulatorComponent } from '../simulator/simulator.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
